import { Box, Typography } from '@mui/material'

const UserDetailsItem = ({ title, value }) => (
  <Box
    sx={{
      p: 1.5,
      borderRadius: 2,
      bgcolor: 'rgba(255,255,255,.025)',
      border: '1px solid rgba(255,255,255,.035)',
      boxShadow: '0 4px 8px rgba(0,0,0,.35)',
    }}>
    <Typography
      variant='caption'
      sx={{
        display: 'block',
        opacity: 0.65,
        mb: 0.5,
      }}>
      {title}
    </Typography>

    <Typography
      sx={{
        fontWeight: 600,
        wordBreak: 'break-word',
      }}>
      {value || '-'}
    </Typography>
  </Box>
)

const UserDetails = ({ userRole, backColor }) => (
  <Box
    sx={{
      display: 'flex',
      justifyContent: 'center',
      mt: -2.5,
      px: 3,
      pb: 3,
    }}>
    <Box
      sx={{
        width: '100%',
        bgcolor: backColor,
        borderRadius: 3,
        boxShadow: '0 12px 35px rgba(0,0,0,.35)',
        border: '1px solid rgba(255,255,255,.08)',
        p: 2,
      }}>
      <Typography
        variant='h6'
        sx={{
          mb: 1,
          fontWeight: 600,
        }}>
        User Details
      </Typography>
      <Box
        sx={{
          display: 'grid',
          gridTemplateColumns: 'repeat(2,minmax(0,1fr))',
          gap: 1.5,
        }}>
        <UserDetailsItem title='Role' value={userRole?.name} />
        <UserDetailsItem title='Units' value={userRole?.userPrefs?.unitPrefs} />
      </Box>
    </Box>
  </Box>
)

export default UserDetails
